import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 25,
  },
  icon: {
    paddingTop: ({ noPadding }) => (noPadding ? 0 : 4),
  },
});

const MenuItemContentWithIcon = ({ label, icon, noPadding = false }) => {
  const classes = useStyles({ noPadding });

  return (
    <div className={classes.root}>
      {icon && <div className={classes.icon}>{icon}</div>}
      <div>{label}</div>
    </div>
  );
};

export default MenuItemContentWithIcon;
